import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class LoginRoute extends Route {
  @service session;
  @service router;

  beforeModel() {
    if (this.session.isAuthenticated) {
      this.router.transitionTo("dashboard");
    }
  }

  setupController(controller, ...args) {
    super.setupController(controller, ...args);
    controller.setupController();
  }

  resetController(controller, ...args) {
    super.resetController(controller, ...args);
    controller.resetController();
  }
}
